import { Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const TESTIMONIALS = [
  {
    quote:
      "Tyrell managed our entire renovation from start to finish. One point of contact, clear updates every week, and the finish is exceptional — nothing was ever too much trouble.",
    name: "S. M.",
    role: "Homeowner",
    location: "Chigwell, Essex",
  },
  {
    quote:
      "The extension was coordinated brilliantly. Trades arrived when promised, the site was always tidy, and we always knew exactly what was happening next.",
    name: "D. R.",
    role: "Homeowner",
    location: "Epping, Essex",
  },
  {
    quote:
      "Professional, straightforward and genuinely focused on quality. They approached our property like an investment, not just a job — which is exactly what we wanted.",
    name: "A. K.",
    role: "Property Investor",
    location: "Brentwood, Essex",
  },
];

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="bg-[#050B14] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-14">
        <div className="mb-6 flex items-center gap-4">
          <span className="h-px w-12 bg-gradient-to-r from-[#C5A059] to-transparent" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#C5A059]">Client Words</span>
        </div>
        <h2 className="font-serif text-3xl font-light uppercase leading-snug tracking-tight text-white sm:text-4xl lg:text-5xl">
          What Clients <span className="gold-text-gradient">Say.</span>
        </h2>
      </Reveal>

      <div className="grid gap-5 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={i} delay={i * 0.12}>
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="flex h-full flex-col border border-[#C5A059]/20 bg-[#0E1726]/60 p-8 transition-colors duration-500 hover:border-[#C5A059]/50"
            >
              <div className="flex items-center justify-between">
                <Quote size={26} className="text-[#C5A059]/70" />
                <span className="border border-dashed border-[#C5A059]/40 px-2.5 py-1 text-[9px] font-bold uppercase tracking-[0.2em] text-[#C5A059]/80">
                  Sample
                </span>
              </div>
              <blockquote className="mt-6 flex-1 font-serif text-lg italic leading-relaxed text-slate-300">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-8 border-t border-[#C5A059]/15 pt-5">
                <span className="block text-sm font-medium text-white">{t.name}</span>
                <span className="mt-0.5 block text-xs uppercase tracking-[0.2em] text-slate-500">
                  {t.role} — {t.location}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-8 text-xs font-light text-slate-600">
          Sample testimonials shown for layout — genuine client reviews will replace these as projects complete.
        </p>
      </Reveal>
    </div>
  </section>
);
